import Icon from '../../../components/AppIcon';

const StepIndicator = ({ currentStep, totalSteps, steps }) => {
  return (
    <div className="mb-4 md:mb-8">
      <div className="flex items-center justify-between relative max-w-4xl mx-auto px-2">
        {/* Progress Line Background */}
        <div className="absolute top-4 md:top-5 right-0 left-0 h-0.5 bg-slate-200 -z-10" />
        {/* Active Progress Line */}
        <div 
          className="absolute top-4 md:top-5 right-0 h-0.5 bg-primary -z-10 transition-all duration-500"
          style={{ width: `${((currentStep - 1) / (totalSteps - 1)) * 100}%` }}
        />
        
        {steps?.map((step) => (
          <div key={step?.id} className="flex flex-col items-center gap-1.5 md:gap-3 relative flex-1">
            <div
              className={`w-8 h-8 md:w-10 md:h-10 rounded-full flex items-center justify-center text-xs md:text-sm font-semibold transition-all duration-300 ${
                currentStep > step?.id
                  ? 'bg-primary text-primary-foreground shadow-md'
                  : currentStep === step?.id
                  ? 'bg-slate-100 border-2 border-primary'
                  : 'bg-slate-100 border-2 border-slate-200'
              }`}
            >
              {currentStep > step?.id && (
                <Icon name="Check" size={14} className="md:w-[18px] md:h-[18px]" />
              )}
            </div>
            {/* Hide labels on very small screens, show on larger mobile */}
            <span
              className={`text-[10px] md:text-xs font-medium text-center max-w-[60px] md:max-w-[80px] transition-colors hidden sm:block ${
                currentStep >= step?.id
                  ? 'text-slate-900' :'text-slate-400'
              }`}
            >
              {step?.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;